import styles from "./styles.module.scss";

export type IconSize = "small" | "medium" | "large" | "xLarge" | "xxLarge" | "inputfieldSize";

interface Props {
  icon: string;
  size: IconSize;
  alt?: string;
  type?: ".svg" | ".png";
  style?: React.CSSProperties;
}

export function IconAtom(props: Readonly<Props>) {
  const styleSize = styles[`icon--${props.size}`];
  const className = ` ${styleSize}`;
  const src = `/assets/icons/${props.icon}${props.type ?? ".svg"}`;

  return <img className={className} alt={props.alt} src={src} style={props.style} />;
}
